/**
 * The registration a Mexican SAPI owes in the National Registry of Foreign Investments (Ley de Inversion
 * Extranjera art. 32; owner decision 2026-10-24, M-30). Visible only to the designated compliance officer
 * and super_admins: the server answers 403 to everyone else.
 *
 *   GET  /api/v1/compliance/rnie-registrations   the SAPIs that owe it, soonest due first
 *   POST /api/v1/compliance/rnie-registrations   record that the company filed (date and the folio the Registry gave)
 */
import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export interface RegistrationOwed {
  legal_entity_id: string;
  /** The series the company holds, by the portal names; null when funds has not announced it. */
  entity_name: string | null;
  first_counted_on: string;
  due_on: string;
  business_days_left: number;
  overdue: boolean;
  foreign_partners: number;
}

export interface RecordRegistrationInput {
  legal_entity_id: string;
  filed_on: string;
  folio: string;
}

const BASE = '/api/v1/compliance/rnie-registrations';

class RnieRegistrationsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async owed(): Promise<RegistrationOwed[]> {
    return (await this.api.get<RegistrationOwed[]>(BASE)).data;
  }

  async record(body: RecordRegistrationInput): Promise<void> {
    await this.api.post(BASE, body);
  }
}

export default new RnieRegistrationsService();
